import { reportError } from '~/utility/reportError'

export function categorySvg(slug: string) {
  try {
    return require(`~/assets/images/category-icons/${slug}.svg?data`)
  } catch (err) {
    reportError(err as Error)
    return ''
  }
}
